<template>
  <!-- The organic door's Stage 0 (navigation-design §2, S0c): Mystic Aida's
       room, not her profile page. Her portrait, one line, the box, "✦ Draw a
       card" with three starters, and one quiet way to the lessons. Nothing is
       asked before the draw; the draw makes a guest place (API §7). -->
  <div class="organic-room" data-testid="organic-room">
    <div class="or-head">
      <img v-if="portrait && !broken" :src="portrait" alt="" class="or-portrait" @error="broken = true" />
      <span v-else class="or-portrait or-initial" aria-hidden="true">M</span>
      <div>
        <p class="or-eyebrow">Mystic Aida</p>
        <h1 class="or-title">What's on your mind?</h1>
      </div>
    </div>
    <div class="or-bubble">
      <span class="or-from">Mystic Aida</span>
      <p>I'm Mystic Aida. Tell me what you're carrying in a few words, and we'll draw on it together.</p>
    </div>
    <form class="or-form" @submit.prevent="send">
      <label class="sr-only" for="or-box">Ask Mystic Aida anything</label>
      <input id="or-box" v-model="words" class="or-box" type="text" placeholder="Ask Mystic Aida anything…" autocomplete="off"
             data-testid="organic-box" />
    </form>
    <div class="or-chips">
      <button class="or-chip or-draw" data-testid="organic-draw" @click="draw('')">✦ Draw a card</button>
      <button v-for="c in STARTERS" :key="c" class="or-chip" :data-testid="`organic-starter-${c.toLowerCase().replace(/\W+/g, '-')}`" @click="draw(c)">{{ c }}</button>
    </div>
    <p class="or-lesson">People sharing what the cards taught them: <button class="or-link" data-testid="organic-lesson" @click="$emit('lessons')">read a lesson</button></p>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import '@/assets/fonts/letter/letter-fonts.css'

defineProps({ portrait: { type: String, default: '' } })
const emit = defineEmits(['ask', 'lessons'])
const STARTERS = ['Love', 'Work', "What's next"]
const words = ref('')
const broken = ref(false)

function send () {
  const w = words.value.trim()
  emit('ask', w)
}
function draw (topic) {
  const typed = words.value.trim()
  emit('ask', typed || topic)
}
</script>

<style scoped>
.organic-room { max-width: 560px; margin: 0 auto; padding: calc(var(--tra-clear-top, 64px) + 12px) 16px 120px; color: #e9dcff; box-sizing: border-box; }
.or-head { display: flex; align-items: center; gap: 16px; margin-bottom: 18px; }
.or-portrait { width: 76px; height: 76px; border-radius: 50%; object-fit: cover; border: 1px solid rgba(201,169,78,0.55); flex: 0 0 auto; }
.or-initial { display: inline-flex; align-items: center; justify-content: center; font-family: 'Letter Display', 'Cinzel', serif; font-size: 28px; color: #f0d9a3; background: #2a1845; }
.or-eyebrow { margin: 0 0 2px; font-family: 'Letter Display', 'Cinzel', serif; font-size: 11px; letter-spacing: 3px; text-transform: uppercase; color: #c9a94e; }
.or-title { margin: 0; font-family: 'Letter Serif', 'Cormorant Garamond', Georgia, serif; font-size: 28px; font-weight: 600; color: #fff4dc; line-height: 1.1; }
.or-bubble { padding: 12px 14px; border-radius: 16px; border: 1px solid rgba(155,134,201,0.3); background: rgba(31,16,58,0.85); margin-bottom: 14px; }
.or-from { display: block; font-size: 12px; color: #b9a6df; margin-bottom: 4px; }
.or-bubble p { margin: 0; font-family: 'Letter Serif', 'Cormorant Garamond', Georgia, serif; font-size: 18px; line-height: 1.45; color: #efe6ff; }
.or-form { margin-bottom: 12px; }
.or-box { width: 100%; box-sizing: border-box; min-height: 46px; padding: 10px 14px; border-radius: 14px; border: 1px solid rgba(155,134,201,0.45);
  background: rgba(15,6,32,0.9); color: #f3ecff; font-size: 16px; }
.or-box::placeholder { color: #8e7bb5; }
.or-chips { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 18px; }
.or-chip { min-height: 44px; padding: 8px 16px; border-radius: 999px; border: 1px solid rgba(201,169,78,0.5); background: rgba(26,12,52,0.9);
  color: #f0d9a3; font-size: 15px; cursor: pointer; }
.or-draw { background: linear-gradient(180deg, #f0d9a3, #c9a94e); color: #1a0f2e; border: none; font-weight: 600; }
.or-lesson { margin: 0; font-size: 14px; color: #8e7bb5; }
.or-link { background: none; border: none; padding: 0; color: #b9a6df; text-decoration: underline; font-size: inherit; cursor: pointer; min-height: 32px; }
.or-chip:focus-visible, .or-link:focus-visible, .or-box:focus-visible { outline: 2px solid #f0d9a3; outline-offset: 2px; }
.sr-only { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
</style>
